"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFetchJson = void 0;
const create_fetch_response_1 = require("./create-fetch-response");
async function formatErrorResponse(response) {
    const text = await response.text();
    try {
        return JSON.stringify(JSON.parse(text), null, 2);
    }
    catch (error) {
        return text;
    }
}
function createFetchJson(config) {
    const { logger = console } = config;
    const fetchResponse = (0, create_fetch_response_1.createFetchResponse)(config);
    async function fetchJson(serviceConfig, serviceName, options = {}) {
        const response = await fetchResponse(serviceConfig, serviceName, options);
        if (!response) {
            return;
        }
        try {
            if (!response.ok) {
                logger.error("Error while fetching data:", response.url, response.status, response.statusText);
                logger.error(await formatErrorResponse(response));
                return;
            }
            return await response.json();
        }
        catch (error) {
            logger.error("Error while parsing fetched data:", response.url, response.status, response.statusText, error);
            return;
        }
    }
    fetchJson.initialize = fetchResponse.initialize;
    fetchJson.getMetrics = fetchResponse.getMetrics;
    return fetchJson;
}
exports.createFetchJson = createFetchJson;
